module.exports = __webpack_public_path__ + "static/img/Ir.e32b339.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Ir.png
// module id = g88+
// module chunks = 1